import { Box, Grid, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { CmpButton, CmpDatePicker, CmpSelectBox, CmpTypographyField } from '../../Component/Common/ToolBox/ToolBox';
import { useSelector } from 'react-redux';
import { GetGitterColumns} from '../../Utility/Utilitys';
import { DataGrid, GridToolbar } from '@mui/x-data-grid'; 
import moment from 'moment';
import { common_InboundProcessFlow_GETROW } from '../../Server/ApiV2';

 

const InboundProcessFlowReport = () => {
    const LocFocusOnLoad = useRef(null);
    const vMediaQuery = useMediaQuery("(max-width:450px)");
    const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value); 
    
    const [grnStatusData, setgrnStatusData] = useState([
        { uid: "All", name: "All" },
        { uid: "Enter", name: "Enter" },
         { uid: "Draft", name: "Draft" },
         { uid: "Post", name: "Post" },
      ]);
    const [putAwayStatusData, setputAwayStatusData] = useState([
        { uid: "All", name: "All" },
        { uid: "Enter", name: "Enter" },
        { uid: "Post", name: "Post" },
      ]);

    const [summaryObj, setSummaryObj] = useState({
        loc: vRdxuserLoc[0]?.UID,
        fromDate: new Date(),
        toDate: new Date(),
        grnStatus:"All",
        putAwayStatus:"All"
    });
    const [sGridrows, setGridrows] = useState([]);

    const fSummary_OnChange = (e) => {
        setSummaryObj((obj) => ({
          ...obj,
          [e.target.name]: e.target.value,
        }));
      };

      const fLoad = () =>{
        GetSummaryList();
      }

      const GetSummaryList = async () => {
        let vSummaryListObj = {
            v_Loc: summaryObj.loc == ""?vRdxuserLoc[0]?.UID: summaryObj.loc,
            v_Date1: moment(summaryObj.fromDate).format("MM/DD/YYYY"),
            v_Date2: moment(summaryObj.toDate,).format("MM/DD/YYYY"),
            v_GRN_DocStat: summaryObj.grnStatus,
            v_PUTAway_DocStat:summaryObj.putAwayStatus
        };
        const vSummaryList = await common_InboundProcessFlow_GETROW(vSummaryListObj
        );
        if (vSummaryList.status == 200) {
          let GridID =vSummaryList.data.ResultSet.length==0?[]: vSummaryList.data.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
          setGridrows(GridID);
        } else { 
          setGridrows([]);
        }
      };


      
  const [Gridcolumns, setGridcolumns] = useState([
    {
      field: "vocCode",
      headerName: "Voc.Code",
      width: 100,
      align: "center",
      headerAlign: "center",
      "hide": true,
    },
    {
      field: "vocName",
      headerName: "Voc.Name",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "vocNo",
      headerName: "Voc.No",
      width: 100,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "postDt",
      headerName: "Date",
      width: 100,
      hide: false,
      align: "center",
      headerAlign: "center",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "party",
      headerName: "Party",
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
        field: "partyName",
        headerName: "Party Name",
        width: 200,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsRcvngStarted",
        headerName: "Rcv.Started",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsRcvngCompl",
        headerName: "Rcv.Completed",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsRcvngPosted",
        headerName: "Rcv.Posted",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "inboudStatus",
        headerName: "Inboud.Status",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsPutAwyAssigned",
        headerName: "Assigned",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsPutAwyStarted",
        headerName: "Started",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsPutAwyCompl",
        headerName: "Completed",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "IsPutAwyPosted",
        headerName: "Posted",
        width: 150,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "putAwayStatus",
        headerName: "PutAway Status",
        width: 150,
        align: "left",
        headerAlign: "left",
      }
  ]);
 
    
    
      useEffect(() => {
        GetGitterColumns(setGridcolumns, "INBOUND_PROCESS_FLOW", Gridcolumns); 
        fLoad();
        LocFocusOnLoad.current?.focus();
      }, []);

  return (
    <div className="container-fluid my-3">
    
    <div className="">
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"Inbound Process Flow Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
    </div>
    <div >
      <Grid
        container
        spacing={{ xs: 2, sm: 2, md: 2 }}
        className="align-items-center mt-4"
      >
        <Grid item lg={2} md={2} xs={6}>
          <CmpSelectBox
            xLabelText="Location"
            xValue={summaryObj.loc === "" ? vRdxuserLoc[0]?.UID : summaryObj.loc}
            xOnChange={(event) => fSummary_OnChange(event)}
            xName={"loc"}
            xData={vRdxuserLoc}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={false}
            xDisable={false}
          />
        </Grid>
        <Grid item lg={2} md={2} xs={6} className="bintransfer-data-date">
          <CmpDatePicker
            xLabelText={"From"}
            xValue={summaryObj.fromDate}
            xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  fromDate: newValue.$d,
                }));
              }}
            xName={"fromDate"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item lg={2} md={2} xs={6} className="bintransfer-data-date">
          <CmpDatePicker
            xLabelText={"To"}
            xValue={summaryObj?.toDate}
            xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  toDate: newValue.$d,
                }));
              }}
            xName={"toDate"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item lg={2} md={2} xs={6}>
          <CmpSelectBox
            xLabelText="GRN Status"
             xValue={summaryObj?.grnStatus}
            xOnChange={(event) => fSummary_OnChange(event)}
            xName={"grnStatus"}
            xData={grnStatusData}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={false}
            xDisable={false}
          />
        </Grid>
        <Grid item lg={2} md={2} xs={6}>
          <CmpSelectBox
            xLabelText="PutAway Status"
             xValue={summaryObj?.putAwayStatus}
             xOnChange={(event) => fSummary_OnChange(event)}
            xName={"putAwayStatus"}
            xData={putAwayStatusData}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={false}
            xDisable={false}
          />
        </Grid>
        <Grid item lg={2} md={2} xs={6} className="bintransfet-data-load-btn">
          <CmpButton
            xbtnName="Load"
            xOnClick={fLoad}
            xVariant="contained"
            xSize="small"
          />
        </Grid>
      </Grid>

      <Box
            sx={{  
      height: {
        xs: "75vh",   
        sm: "60vh",
        md: "60vh",   
        lg: "60vh",   
      }, width: "100%" }}
            className="bin-transfer-data"
          >
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sGridrows}
              columns={Gridcolumns}
              // pageSize={5}
              // rowsPerPageOptions={[5]}
              hideFooter={sGridrows.length < 100}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
              // onRowClick={fOnRowClick}
            />
          </Box>
</div>
</div>
  )
}

export default InboundProcessFlowReport;